/* aurapik cart cross-sell — "Add to your order".
 * Fills the in-drawer strip with related recommendations (falling back to the
 * catalog when the recommender is thin), excluding what's already in the cart.
 * Single-variant items get a one-tap +add (reusing aurapik-card.js's
 * [data-quick-add]); multi-variant items link to their PDP to pick options.
 * Re-populates itself after Dawn re-renders #CartDrawer (renderContents). */
(function () {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const LIMIT = 12;
  const MIN_BEFORE_FALLBACK = 4;

  const esc = (s) =>
    String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function money(cents) {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function img(url) {
    if (!url) return '';
    let u = url.indexOf('//') === 0 ? 'https:' + url : url;
    u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=200';
    return u;
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null);
  }

  function card(p) {
    const purl = String(p.url || '#').split('?')[0];
    const variants = p.variants || [];
    const v = variants.find((x) => x.available) || variants[0];
    const single = variants.length === 1 && v && v.available;
    const sale = p.compare_at_price && p.compare_at_price > p.price;
    const add = single
      ? `<button type="button" class="ap-xcard__add" data-quick-add="${v.id}" aria-label="Add ${esc(p.title)}">+</button>`
      : `<a class="ap-xcard__add" href="${esc(purl)}" aria-label="Choose options for ${esc(p.title)}">+</a>`;
    return (
      `<div class="ap-xcard">` +
      `<a class="ap-xcard__lk" href="${esc(purl)}">` +
      `<span class="ap-xcard__img" style="background-image:url(${esc(img(p.featured_image))})"></span>` +
      `<span class="ap-xcard__t">${esc(p.title)}</span>` +
      `<span class="ap-xcard__p">${money(p.price)}${sale ? ` <s>${money(p.compare_at_price)}</s>` : ''}</span>` +
      `</a>${add}</div>`
    );
  }

  async function gather(cart) {
    const seed = cart && cart.items && cart.items.length ? cart.items[cart.items.length - 1].product_id : null;
    let list = [];
    if (seed) {
      const rec = await getJSON(`${root}recommendations/products.json?product_id=${seed}&intent=related&limit=${LIMIT}`);
      if (rec && rec.products) list = rec.products.slice();
    }
    if (list.length < MIN_BEFORE_FALLBACK) {
      const fb = await getJSON(`${root}products.json?limit=${LIMIT}`);
      if (fb && fb.products) list = list.concat(fb.products);
    }
    return list;
  }

  async function populate(box) {
    box = box || document.querySelector('[data-ap-xsell]');
    // data-xsell: absent = fresh node, 'loading' = in flight, 'done' = settled.
    // The flag is set to 'done' only AFTER rendering, so a transient/early run
    // can't lock in an empty strip; an error clears it so a later mutation retries.
    if (!box || box.getAttribute('data-xsell')) return;
    box.setAttribute('data-xsell', 'loading');
    try {
      const cart = await getJSON(`${root}cart.js`);
      const inCart = new Set((cart && cart.items ? cart.items : []).map((i) => i.product_id));
      const raw = await gather(cart);
      const seen = new Set();
      const picks = [];
      for (const p of raw) {
        if (!p || seen.has(p.id) || inCart.has(p.id) || p.available === false) continue;
        seen.add(p.id);
        picks.push(p);
        if (picks.length >= LIMIT) break;
      }
      const track = box.querySelector('[data-ap-xsell-track]');
      if (picks.length && track) {
        track.innerHTML = picks.map(card).join('');
        box.hidden = false;
      } else {
        box.hidden = true;
      }
      box.setAttribute('data-xsell', 'done');
    } catch (e) {
      box.removeAttribute('data-xsell'); // allow a retry
    }
  }

  function start() {
    populate();
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // After a cart change Dawn replaces #CartDrawer's innerHTML, resetting our
    // (fresh, unflagged) strip — repopulate it. Debounced so the burst of
    // mutations during a re-render collapses into one run against the settled
    // cart; the data-xsell guard stops our own writes from looping.
    let t;
    const obs = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        const box = document.querySelector('[data-ap-xsell]');
        if (box && !box.getAttribute('data-xsell')) populate(box);
      }, 120);
    });
    obs.observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
